<!--
 * @Description: ================== 游戏介绍 =================
 * @Date: 2022-05-13 18:08:07
 * @Author: Zero
 * @FilePath: \guobao-web\src\components\Game.vue
 * @LastEditors: 13113306050 13113306050@163.com
 * @LastEditTime: 2026-09-30 12:05:33
-->
<template>
  <div class="page page-game">
    
    <!-- <pre> -->
    <img src="https://apk.najiahy.com/img2/hhhdir/hyrz/top1.jpg" style="width: 100%;padding-top: 12px;" alt="" />
    <h2 class="title">游戏介绍</h2>
     <p>欢迎来到木叶村落，缔结忍者羁绊，与木叶伙伴奔赴忍界激战！这片波澜壮阔的忍界，等待你的探索。</p>
    <div class="content">

      <div class="content-item">
        <h4>【离线挂机，培育传说忍者】</h4>
        <p>修行不受时限束缚！冒险关卡自动积攒修炼资源，离线也能持续获取收益，每位忍者全天候稳步变强，上线一键收取海量养成材料，等级战力飞速飙升，忍界强者轻松养成！</p>
        <img src="https://apk.najiahy.com/img2/hhhdir/hyrz/top2.jpg" alt="" />
      </div>
      <div class="content-item">
        <h4>【忍者招募，集结全系列强者】</h4>
        <p>强力忍者静待邂逅！开启忍者招募，鸣人、佐助、宇智波斑等经典角色悉数登场，组建专属忍者战队，踏上属于你的忍界冒险！</p>
        <img src="https://apk.najiahy.com/img2/hhhdir/hyrz/top3.jpg" alt="" />
      </div>
      <div class="content-item">
        <h4>【阵营羁绊，复刻原作必杀技】</h4>
       <p> 迎战忍界各路强敌，在冒险章节深处对决反派 BOSS！激活角色阵营羁绊，自由搭配忍者阵容，释放螺旋丸、须佐能乎等经典原作必杀，打出高额合击伤害，称霸忍界战场！</p>
        <img src="https://apk.najiahy.com/img2/hhhdir/hyrz/top4.jpg" alt="" />
      </div>
      <div class="content-item">
        <h4>【勇闯冒险，登顶忍界巅峰】</h4>
        <p>从新人下忍到忍界之巅，你的每一场 BOSS 挑战、每一次忍者进阶，都会记录在忍界榜单。集结全部经典忍者，解锁终极战术，成为纵横五大国的最强勇者！
       忍者们，出发吧 —— 坚守忍道之日，便是梦想成真之时！</p>
        <img src="https://apk.najiahy.com/img2/hhhdir/hyrz/top5.jpg" alt="" />
      </div>
    </div>
    <!-- </pre> -->
  </div>
</template>

<style scss>
.content-item {
  display: inline-block;
  width: 50%;
  padding: 12px;
  box-sizing: border-box;
  vertical-align: bottom;
}
@media screen and (max-width: 768px) {
  .content-item {width: 100%;}
}
.content-item img {
  display: block;
  margin-top: 12px;
}
.content-item p {
  font-size: 14px;
  height: 68px;
}
h4 {
  margin: 6px auto;
}
</style>
